/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Workout_Share_Analysis_WarmupsInputs */

const en_us2_workout_share_analysis_warmups = /** @type {(inputs: Workout_Share_Analysis_WarmupsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 warm-up`);
	return /** @type {LocalizedString} */ (`${i?.count} warm-ups`)
	
};

const pt_br2_workout_share_analysis_warmups = /** @type {(inputs: Workout_Share_Analysis_WarmupsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 de aquecimento`);
	return /** @type {LocalizedString} */ (`${i?.count} de aquecimento`)
	
};

const es_419_workout_share_analysis_warmups = /** @type {(inputs: Workout_Share_Analysis_WarmupsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 de calentamiento`);
	return /** @type {LocalizedString} */ (`${i?.count} de calentamiento`)
	
};

const pt_pt2_workout_share_analysis_warmups = /** @type {(inputs: Workout_Share_Analysis_WarmupsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 de aquecimento`);
	return /** @type {LocalizedString} */ (`${i?.count} de aquecimento`)
	
};

const fr_fr2_workout_share_analysis_warmups = /** @type {(inputs: Workout_Share_Analysis_WarmupsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 série d'échauffement`);
	return /** @type {LocalizedString} */ (`${i?.count} séries d'échauffement`)
	
};

const de_de2_workout_share_analysis_warmups = /** @type {(inputs: Workout_Share_Analysis_WarmupsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 Aufwärmsatz`);
	return /** @type {LocalizedString} */ (`${i?.count} Aufwärmsätze`)
	
};

const it_it2_workout_share_analysis_warmups = /** @type {(inputs: Workout_Share_Analysis_WarmupsInputs) => LocalizedString} */ (i) => {
	if ((i?.count === 1 || i?.count === "1")) return /** @type {LocalizedString} */ (`1 di riscaldamento`);
	return /** @type {LocalizedString} */ (`${i?.count} di riscaldamento`)
	
};

/**
* | count | output |
* | --- | --- |
* | "1" | "1 warm-up" |
* | * | "{count} warm-ups" |
*
* @param {Workout_Share_Analysis_WarmupsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_share_analysis_warmups = /** @type {((inputs: Workout_Share_Analysis_WarmupsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Share_Analysis_WarmupsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_share_analysis_warmups(inputs)
	if (locale === "es-419") return es_419_workout_share_analysis_warmups(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_share_analysis_warmups(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_share_analysis_warmups(inputs)
	if (locale === "de-DE") return de_de2_workout_share_analysis_warmups(inputs)
	if (locale === "it-IT") return it_it2_workout_share_analysis_warmups(inputs)
	return en_us2_workout_share_analysis_warmups(inputs)
});
export { workout_share_analysis_warmups as "workout-share.analysis_warmups" }